import launchCareerImage from "../../img/Business Illustration-03 2.png"; 
import styles from "./AIEngineer.module.css"; 
import { NAV_LINK_CONSTANTS } from "../../Constants/NavLinksContants";


const SummarTrainingDropDown = ({ isMobile = false }) => {
    const handleExploreClick = () => {
        window.open(`${NAV_LINK_CONSTANTS.AGENTIC_AI_PAGE_URL}`, "_blank");
    };

    const disableScroll = () => {
        document.body.style.overflow = "hidden";
    };

    const enableScroll = () => {
        document.body.style.overflow = "auto"; 
    };

    return (
        <div
            className={styles.fellowshipContainer}
            onClick={handleExploreClick}
            onMouseEnter={!isMobile ? disableScroll : null}
            onMouseLeave={!isMobile ? enableScroll : null}
        >
            <div className={styles.fellowshipText}>
                <div className={styles.fellowshipProgramTitle}>Agentic AI</div>
                <div className={styles.launchTechCareerText}>For Next Gen Builders</div>
            </div>
            <div
                className={styles.hoverBox}
                onMouseEnter={!isMobile ? disableScroll : null}
                onMouseLeave={!isMobile ? enableScroll : null}
            >
                <h4 className={styles.launchCareerhead}>LLMs, Deep Learning & Agentic AI</h4>
                <div className={styles.launchCareerImage}>
                    <img src={launchCareerImage} alt="Launch Tech Career" width={200} height={150} />
                </div>
                <div className={styles.hoverBoxButtons}>
                    <button>Gain Production Grade Depth</button>
                    <button>Build Resilient AI Agents</button>
                    <button>Ace AI-ML interviews</button>
                </div>
                <button className={styles.exploreProgramBtn} onClick={() => window.open(`${NAV_LINK_CONSTANTS.AGENTIC_AI_PAGE_URL}`, "_blank")}>Explore the Program</button>
            </div>
        </div>
    );
}


export default SummarTrainingDropDown;